import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class TagService {
  async getTagByProgramId(programId, accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/adminTags/${programId}`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const tagService = new TagService()
